<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
    name: "table-tahapan-diklat",
    props: {
        mkp_kode_pembelajaran: {
            type: String,
            required: true
        },
        mkp_judul: {
            type: String,
            required: true
        },
        idPembelajaran: {
            type: String,
            required: true
        }
    },
    components: [
    ],
    data() {
        return {
            app_url: process.env.VUE_APP_URL,
            loadingTable: true,
            get_data: [],
            modalFormImplementation: false,
            modalEditFormStages: false,
            modalFormUpload: false,
            modalLink: false,
            modalUploadFile: false,
            mkp_id_agenda: '',

            user_role: localStorage.getItem("session_role_active_id"),

            implementation: {
                p_id: null,
                mkp_id: null,
                mkp_id_agenda: null,
                tanggal_pelaksanaan: null,
                waktu_pelaksanaan: null
            },

            selectStage: '',
            currentStagesValue: '',
            optionStage: [
                { value: 'pembukaan', text: 'Pembukaan' },
                { value: 'sync', text: 'Sync' },
                { value: 'async', text: 'Async' },
                { value: 'pembelajaran_mandiri', text: 'Pembelajaran mandiri' },
                { value: 'materi', text: 'Materi' },
            ],

            mkp_id_agenda_pelaksanaan: null,

            mkp_id: "",
            titleMateri: "",
            upFilePdf: "",
            upFilePpt: "",
            dateAgenda: "",
            durationAgenda: "",
            durationStart: "",
            durationEnd: "",
            selectInstruktur: "",
            detailAgenda: "",
            selectGroup: "",
            linkAgenda: "",
            linkFile: "",
            linkVideo: "",
            questionUpload: "",
            uploadFilePdf: "",
            uploadFilePpt: "",
            path_materi_pdf: "",
            path_materi_ppt: "",
            titleKelompokAdd: [],
            instruktur_data: [],
            peserta_ref: [],

            dateImplementation: "",
            timeImplementation: "",

            table_data: [],

            // show modal status
            showModal: {
                detailStages: false,
            },
            detailStagesMode: true,

            dataStage: {
                mkp_id_agenda: null,
                mkp_id: null,
                type_stages: null,
                title_agenda: null,
                date_agenda: null,
                duration_agenda: null,
                duration_start: null,
                duration_end: null,
                instruktur: null,
                detail_agenda: null,
                group: null, 
                link_agenda: null,
                link_file: null,
                link_video: null,
                is_upload: null,
                is_online_meet: null,
                titleKelompokAdd: null,
                instruktur_data: [],
                uploadFilePdf: null,
                uploadFilePpt: null,
                materi_pdf: null,
                materi_ppt: null,
                path_materi_pdf: null,
                path_materi_ppt: null,
                upFilePdf: "",
                upFilePpt: "",
            },

            listOptSelectStage: [],

        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            var config = {
                method: "get",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/agenda",
                params: {
                    id: this.idPembelajaran,
                    kode: this.mkp_kode_pembelajaran,
                    judulPembelajaran: this.mkp_judul
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config).then((res) => {
                var resFix = res.data.data[0];
                if (resFix != '') {
                    this.table_data = this.preprocessTableData(resFix);
                    // console.log("Data Path PDF:", this.table_data.map(data => data.path_materi_pdf));
                } else {
                    console.log("Hasil Data Kosong");
                }
                this.loadingTable = false;
            });
        },

        

        getDataImplementation(mkp_id_agenda_pelaksanaan) {
            let self = this;

            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });

            var config = {
                method: "get",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/tahapan-diklat",
                params: {
                    kode: this.mkp_kode_pembelajaran,
                    judulPembelajaran: this.mkp_judul,
                    mkp_id_agenda_pelaksanaan: mkp_id_agenda_pelaksanaan
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config).then((res) => {
                var responseData = res.data.data[0];
                console.log("test----------");
                console.log(self.implementation.p_id);

                if (res.data.data != 'dataEmpty') {
                    self.implementation.p_id = responseData.p_id;
                    self.implementation.mkp_id = responseData.mkp_id;
                    self.implementation.mkp_id_agenda = responseData.mkp_id_agenda;
                    self.implementation.tanggal_pelaksanaan = responseData.tanggal_pelaksanaan;
                    self.implementation.waktu_pelaksanaan = responseData.waktu_pelaksanaan;

                    self.dateImplementation = responseData.tanggal_pelaksanaan;
                    self.timeImplementation = responseData.waktu_pelaksanaan;
                }

                Swal.close();
                console.log(self.implementation);
            });
        },

        showFormImplemantation(mkp_id_agenda) {
            this.mkp_id_agenda_pelaksanaan = mkp_id_agenda;
            this.modalFormImplementation = true;

            this.getDataImplementation(mkp_id_agenda);
        },
        showEditFormStages(mkp_id_agenda) {
            let self = this;

            this.mkp_id_agenda = mkp_id_agenda;

            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });

            this.selectStage = '';

            var config_axios = {
                method: "get",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/getDataAgenda",
                params: {
                    mkp_id_agenda: mkp_id_agenda,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };
            axios(config_axios)
                .then((response) => {
                    this.modalEditFormStages = true;

                    Swal.close();
                    var dataStage = response.data.data[0][0];
                    self.selectStage = dataStage.type_stages;
                    self.currentStagesValue = dataStage.type_stages;

                    self.mkp_id_agenda = dataStage.mkp_id_agenda;
                    self.mkp_id = dataStage.mkp_id;
                    self.titleMateri = dataStage.title_agenda;
                    self.dateAgenda = dataStage.date_agenda;
                    self.durationStart = dataStage.duration_start;
                    self.durationEnd = dataStage.duration_end;
                    self.selectInstruktur = dataStage.instruktur;
                    self.selectGroup = dataStage.group;
                    self.durationAgenda = dataStage.duration_agenda;
                    self.detailAgenda = dataStage.detail_agenda;
                    self.linkAgenda = dataStage.link_agenda;
                    self.linkFile = dataStage.link_file;
                    self.linkVideo = dataStage.link_video;
                    self.questionUpload = dataStage.is_upload;
                    self.titleKelompokAdd = dataStage.kelompok_instruktur;
                    self.instruktur_data = dataStage.instruktur;
                    // self.upFilePpt = dataStage.path_materi_ppt;
                    // self.upFilePdf = dataStage.path_materi_pdf;

                    self.upFilePpt = process.env.VUE_APP_BACKEND_URL + dataStage.path_materi_ppt;
                    self.upFilePdf = process.env.VUE_APP_BACKEND_URL + dataStage.path_materi_pdf;
                })
                .catch((errors) => {
                    console.log(errors);
                    Swal.close();
                });
        },
                openFile(fileUrl) {
            if (fileUrl && fileUrl !== "null" && fileUrl !== "") {
                window.open(fileUrl, "_blank");
            } else {
                Swal.fire("Error", "File tidak ditemukan", "error");
            }
        },
   
        storeDateTimeImplementation() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
            });

            var configStoreData = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/tahapan-diklat",
                data: {
                    kode_pembelajaran: self.mkp_kode_pembelajaran,
                    judul_pembelajaran: self.mkp_judul,
                    mkp_id_agenda: self.mkp_id_agenda_pelaksanaan,
                    dateImplementation: self.dateImplementation,
                    timeImplementation: self.timeImplementation
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                }
            };
            axios(configStoreData)
                .then(function (response) {
                    console.log(response);
                    Swal.fire({
                        icon: "success",
                        title: "Berhasil",
                        text: "Data berhasil di simpan !",
                        timer: 2000,
                        timerProgressBar: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.timer) {
                            Swal.close();
                            // self.$router.push({ name: "all-kode-pembelajaran" });
                            self.modalFormImplementation = false;
                        }
                    });
                })
                .catch(function (error) {
                    self.axiosCatchError = error.response.data.data;
                    Swal.close();
                });
        },
        addRowPeserta() {
        this.instruktur_data.push({
        instruktur_data: JSON.parse(JSON.stringify(this.instruktur_data)),
        kelompok_instruktur: self.titleKelompokAdd,
      });
    },

    // Hapus baris tertentu
    deleteRow(index) {
      this.instruktur_data.splice(index, 1);
    },

    // Cari instruktur berdasarkan input
    onSearchInstruktur(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPeserta(loading, search);
      }
    },

    // Metode untuk memanggil API pencarian instruktur
    searchPeserta(loading, search) {
      const config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/search-instruktur",
        params: { search },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          if (response.data?.meta?.code === 200) {
            this.peserta_ref = response.data.data.referensi;
          } else {
            this.peserta_ref = [{ user_id: 0, username: "-" }];
          }
          loading(false);
        })
        .catch(() => {
          this.peserta_ref = [{ user_id: 0, username: "-" }];
          loading(false);
        });
    },

            uploadFilePpdf(event) {
            const file = event.target.files[0];
            const errorMessage = this.isValidPdf(file, this.maxFileSize);

            if (errorMessage) {


                this.errorMessage = errorMessage;
                document.getElementById("uploadLoadingPdf").innerText = this.errorMessage;
            } else {
                this.dataStage.upFilePdf = file; // Simpan nama file baru
                this.errorMessage = "";
                document.getElementById("uploadLoadingPdf").innerText = "File siap diunggah.";
            }
            console.log(this.dataStage.upFilePdf);
            },
            isValidPdf(file, maxFileSize) {
            if (!file) return "Silakan pilih file terlebih dahulu.";
            if (file.type !== "application/pdf") {
                return "File harus dalam format PDF.";
            }
            if (file.size > maxFileSize) {
                return "Ukuran file maksimal adalah 2 MB.";
            }
            return "";
            },



            uploadFilePptt(event) {
            const file = event.target.files[0];
            const errorMessage = this.isValidPpt(file, this.maxFileSize);

            if (errorMessage) {
                this.errorMessage = errorMessage;
                document.getElementById("uploadLoadingPpt").innerText = this.errorMessage;
            } else {
                this.dataStage.upFilePpt = file; // Simpan nama file baru
                this.errorMessage = "";
                document.getElementById("uploadLoadingPpt").innerText = "File siap diunggah.";
            }
            console.log(this.dataStage.upFilePpt);
            },
            isValidPpt(file, maxFileSize) {
            if (!file) return "Silakan pilih file terlebih dahulu.";
            if (
                file.type !== "application/vnd.ms-powerpoint" &&
                file.type !== "application/vnd.openxmlformats-officedocument.presentationml.presentation"
            ) {
                return "File harus dalam format PPT atau PPTX.";
            }
            if (file.size > maxFileSize) {
                return "Ukuran file maksimal adalah 2 MB.";
            }
            return "";
            },
            getFileName(url) {
            //     if (typeof url !== "string" || !url) {
            //     return "Belum ada file";
            // }
            return url.substring(url.lastIndexOf('/') + 1);
            },


          selectStages() {
            if (this.notEmptyFormStages()) {
                Swal.fire({
                    title: 'Tipe Tahapan Diganti',
                    html: 'Beberapa input di form Tahapan sudah terisi<br>Apakah tipe tahapan tetap akan diganti ?<br><small style="color:red;">*Isi form akan dikosongkan</small>',
                    icon: 'warning',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Ya, ganti tahapan',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.titleMateri = "";
                        this.questionUpload = "";

                        this.currentStagesValue = this.selectStage;

                        this.resetFormStages();
                    } else {
                        this.selectStage = this.currentStagesValue;
                    }
                })
            } else {
                this.currentStagesValue = this.selectStage;
            }
        },

        closeModalStages() {
            if (this.notEmptyFormStages()) {
                Swal.fire({
                    title: 'Tutup Form Tahapan ?',
                    text: 'Beberapa input pada form Tahapan sudah terisi\nBila form di tutup, maka isi form akan kosongkan !',
                    icon: 'warning',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Batal Edit, Tutup Form Tahapan',
                    cancelButtonText: 'Batal',
                    customClass: {
                        confirmButton: 'btnSuccess',
                        cancelButton: 'btnDanger',
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.resetFormStages();
                    } else {
                        this.modalEditFormStages = true;
                    }
                });
            }
        },

                DataInstruktur() {
        // Variabel sementara untuk menyimpan id instruktur dan kelompok
        let userIds = [];
        let titleKelompok = [];

        this.instruktur_data.forEach((data) => {
            // Simpan hanya user_id ke dalam array userIds
            if (data.data_instruktur && data.data_instruktur.user_id) {
            userIds.push(data.data_instruktur.user_id);
            }
            // Simpan titleKelompokAdd ke dalam array titleKelompok
            if (data.titleKelompokAdd) {
            titleKelompok.push(data.titleKelompokAdd);
            }
        });

        // Assign array user_id dan titleKelompok ke property komponen
        this.instruktur_data = userIds; // Hanya berisi user_id
        this.titleKelompokAdd = titleKelompok;

        console.log("Kelompok Instruktur:", this.titleKelompokAdd);
        console.log("Instruktur IDs:", this.instruktur_data);
        },


        prepareDataToSend() {
  const updatedInstruktur = this.instruktur_data.map((row, index) => {
    // Gunakan data lama jika input kosong, atau data yang diinputkan jika ada
    return row.data_instruktur || this.dataStage.instruktur_data[index]?.data_instruktur || null;
  });

  const updatedKelompok = this.titleKelompokAdd.map((row, index) => {
    // Gunakan data lama jika input kosong, atau data yang diinputkan jika ada
    return row || this.dataStage.titleKelompokAdd[index] || "";
  });

  // Menambahkan data ke FormData
  const formData = new FormData();
  formData.append("instruktur", JSON.stringify(updatedInstruktur)); 
  formData.append("kelompok_instruktur", JSON.stringify(updatedKelompok));

  return formData;
},

        storeEditDataStages() {
        let self = this;

   
        const formData = this.prepareDataToSend();


    // Tampilkan loader
    Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
    });

   

    formData.append("mkp_id", self.dataStage.mkp_id === 'null' ? null : self.dataStage.mkp_id);
    formData.append("mkp_id_agenda", self.dataStage.mkp_id_agenda);
    formData.append("type_stages", self.dataStage.type_stages);
    formData.append("title_agenda", self.dataStage.title_agenda);
    formData.append("date_agenda", self.dataStage.date_agenda);
    formData.append("duration_agenda", self.dataStage.duration_agenda);
    formData.append("duration_start", self.dataStage.duration_start);
    formData.append("duration_end", self.dataStage.duration_end);
    formData.append("group", self.dataStage.group);
    formData.append("detail_agenda", self.dataStage.detail_agenda);
    formData.append("link_agenda", self.dataStage.link_agenda);
    formData.append("link_file", self.dataStage.link_file);
    formData.append("link_video", self.dataStage.link_video);
    formData.append("is_upload", self.dataStage.is_upload);
    formData.append("is_online_meet", self.dataStage.is_online_meet);

  
    // JSON stringifying array fields
    formData.append("kelompok_instruktur", JSON.stringify(this.titleKelompokAdd));
    formData.append("instruktur", JSON.stringify(this.instruktur_data));


    
    // Tambahkan file jika ada
    if (self.dataStage.upFilePpt) {
        formData.append("materi_ppt", self.dataStage.upFilePpt);
    }
    if (self.dataStage.upFilePdf) {
        formData.append("materi_pdf", self.dataStage.upFilePdf);
    }
    


    // Konfigurasi Axios untuk PUT
    const configStoreData = {
        method: "post",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/editAgenda",
        data: formData,
        
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
        },
        
    };

    
    // Kirim request menggunakan Axios
    axios(configStoreData)
        .then(function (response) {
            console.log("Response:", response);

            Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan!",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
            }).then((result) => {
                if (result.dismiss === Swal.DismissReason.timer) {
                    Swal.close();

                    // Tampilkan detail data
                    self.showModalDetailStages(self.dataStage.mkp_id_agenda);

                    // Refresh data tabel
                    self.loadingTable = true;
                    self.getData();
                }
            });
        })
        .catch(function (error) {
            console.error("Error Response:", error.response); // Cek error dari server
            console.log("FormData yang dikirim:", [...formData.entries()]); // Log isi FormData untuk debugging

            self.axiosCatchError = error.response.data.data; // Simpan pesan error
            Swal.close();
        });
},
        
        deleteStages() {
            let self = this;

            Swal.fire({
                title: 'Hapus Agenda',
                text: self.dataStage.title_agenda,
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                customClass: {
                    confirmButton: 'btnSuccess',
                    cancelButton: 'btnDanger',
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: '<i class="fas fa-spinner fa-spin"></i>',
                        text: "Loading...",
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });

                    var config_axios = {
                        method: "delete",
                        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/tahapan-diklat",
                        params: {
                            mkp_id_agenda: self.dataStage.mkp_id_agenda,
                            kode_pembelajaran: this.mkp_kode_pembelajaran,
                            judul_pembelajaran: this.mkp_judul,
                        },
                        headers: {
                            Accept: "application/json",
                            Authorization: "Bearer " + localStorage.access_token,
                        },
                    };
                    axios(config_axios).then((response) => {
                        console.log(response);
                        self.showModal.detailStages = false;
                        Swal.close();

                        this.loadingTable = true;
                        this.getData();
                    }).catch((errors) => {
                        alert(errors);
                        self.showModal.detailStages = true;
                        Swal.close();
                    });
                } else {
                    self.showModal.detailStages = true;
                }
            });
        },
        
    
        preprocessTableData(data) {
            const processedData = [];
            let currentRowspan = 1;
            let currentGroupStartIndex = 0;

            for (let i = 0; i < data.length; i++) {
                if (i > 0 && data[i].date_agenda === data[i - 1].date_agenda) {
                    currentRowspan++;
                    processedData[currentGroupStartIndex].rowspan = currentRowspan;
                    processedData.push({
                        ...data[i],
                        showDate: false
                    });
                } else {
                    currentRowspan = 1;
                    currentGroupStartIndex = processedData.length;
                    processedData.push({
                        ...data[i],
                        rowspan: currentRowspan,
                        showDate: true
                    });
                }
            }
            return processedData;
        },
        showModalLink() {
            this.modalLink = true;
        },
        closeModalLink() {
            this.modalLink = false;
        },

        showModalFormUpload() {
            this.modalFormUpload = true;
        },
        closeModalFormUpload() {
            this.modalFormUpload = false;
        },

        showModalUploadFile() {
            this.modalUploadFile = true;
        },
        closeModalUploadFile() {
            this.modalUploadFile = false;
        },
        showModalDetailStages(mkp_id_agenda) {
            let self = this;

            self.detailStagesMode = true; // modal on mode detail data, if else modal on mode edit data
            self.resetDataStage();
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });

            var config = {
                method: "get",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/getDataAgenda",
                params: {
                    mkp_id_agenda: mkp_id_agenda,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config).then((response) => {
                var resData = response.data.data[0][0];
                var resStatus = response.status;

                self.showModal.detailStages = true;
                
                if (resStatus == 200) {
                    self.dataStage.type_stages = resData.type_stages;
                    self.dataStage.mkp_id_agenda = resData.mkp_id_agenda;
                    self.dataStage.mkp_id = resData.mkp_id;
                    self.dataStage.title_agenda = resData.title_agenda;
                    self.dataStage.date_agenda = resData.date_agenda;
                    self.dataStage.duration_agenda = resData.duration_agenda;
                    self.dataStage.duration_start = resData.duration_start;
                    self.dataStage.duration_end = resData.duration_end;
                    self.dataStage.instruktur = resData.instruktur;
                    self.dataStage.detail_agenda = resData.detail_agenda;
                    self.dataStage.group = resData.group;
                    self.dataStage.link_agenda = resData.link_agenda;
                    self.dataStage.link_file = resData.link_file;
                    self.dataStage.link_video = resData.link_video;
                    self.dataStage.is_upload = resData.is_upload;
                    self.dataStage.is_online_meet = resData.is_online_meet;
                    self.dataStage.titleKelompokAdd = JSON.parse(resData.instruktur);
                    self.dataStage.instruktur_data = JSON.parse(resData.instruktur);
                    self.dataStage.uploadFilePpt = resData.nama_file_ppt;
                    self.dataStage.uploadFilePdf = resData.nama_file_pdf;
                    //self.dataStage.titleKelompokAdd = JSON.parse(resData.kelompok_instruktur);
                    //self.dataStage.instruktur_data = JSON.parse(resData.instruktur);
                    self.dataStage.upFilePdf = process.env.VUE_APP_BACKEND_URL + resData.path_materi_pdf;
                    self.dataStage.upFilePpt = process.env.VUE_APP_BACKEND_URL + resData.path_materi_ppt;
                    
                }

                Swal.close();
            }).catch((errors) => {
                console.log(errors);
                Swal.close();

                Swal.fire({
                    title: 'Gagal ambil data agenda',
                    text: 'Terjadi kesalahan saat ambil data agenda',
                    icon: 'danger',
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                });
            });

        },

        showEditStages() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });

            self.getListTypeStages();
        },

        closeEditStages() {
            this.detailStagesMode = true;
        },
        resetDataStage(){
            this.instruktur_data = [],
            this.dataStage = {
                mkp_id_agenda: null,
                mkp_id: null,
                type_stages: null,
                title_agenda: null,
                date_agenda: null,
                duration_agenda: null,
                duration_start: null,
                duration_end: null,
                instruktur: null,
                detail_agenda: null,
                group: null, 
                link_agenda: null,
                link_file: null,
                link_video: null,
                is_upload: null,
                is_online_meet: null,
                titleKelompokAdd: null,
                instruktur_data: [],
                uploadFilePdf: null,
                uploadFilePpt: null,
                materi_pdf: null,
                materi_ppt: null,
                path_materi_pdf: null,
                path_materi_ppt: null,
                upFilePdf: "",
                upFilePpt: "",
            }
        },

        getListTypeStages() {
            let self = this;

            var config = {
                method: 'get',
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/list-type-agenda",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token
                },
            };

            axios(config).then((response) => {
                var resStatus = response.status;
                if (resStatus == 200) {
                    self.listOptSelectStage = response.data.data[0];
                    self.detailStagesMode = false;
                } else {
                    self.detailStagesMode = true;
                }

                Swal.close();
            }).catch((error) => {
                console.log('Error:', error.response ? error.response.data : error.message);
                self.detailStagesMode = true;
                Swal.close();
            });
        },

        closeModalDetailStages() {
            this.showModal.detailStages = false;
            this.detailStagesMode = true; // modal on mode detail data, if else modal on mode edit data
        }
    },
};
</script>
<style>
th {
    border-color: grey !important;
}

td {
    border-color: grey !important;
}
</style>
<template>
    <div class="table-responsive pb-2 overflow-x-auto">
        <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
            <thead class="bg-dark greyTheme text-center text-white">
                <tr class="align-middle">
                    <th style="min-width: 35vh !important;">Hari / Tanggal</th>
                    <th style="min-width:400px;">Materi</th>
                    <th>Jumlah<br>JP</th>
                    <th style="min-width:200px;">Waktu<br>WIB</th>
                    <th style="min-width:100px;">Link<br>Zoom</th>
                    <th style="min-width:100px;">Link<br>File</th>
                    <th style="min-width:100px;">Link<br>Materi</th>
                    <th style="min-width:100px;">Upload<br>Tugas</th>
                    <th style="min-width:100px; max-width:175px;">Aksi</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loadingTable == true">
                    <td class="text-center" colspan="99">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                </tr>
                <tr v-else-if="table_data == ''">
                    <td class="text-center" colspan="99">Data Tidak Tersedia</td>
                </tr>
                <tr v-else v-for="(row_data, key_data) in table_data" :key="key_data">
                    <!-- <td class="text-center">{{ row_data.date_agenda }}</td> -->
                    <td v-if="row_data.showDate" :rowspan="row_data.rowspan" class="text-center">{{ row_data.date_agenda }}</td>
                    <td><b>{{ row_data.type_stages }}</b> {{ row_data.title_agenda }}</td>
                    <td class="text-center">{{ row_data.duration_agenda }}</td>
                    <td class="text-center" v-if="row_data.duration_start != null">{{ row_data.duration_start }} - {{ row_data.duration_end }}</td>
                    <td v-else class="text-center">-</td>

                    <td class="text-center">
                        <span class="badge rounded-pill bg-success" v-if="row_data.link_agenda != null">
                            <i class="fas fa-check"></i>
                        </span>
                        <span class="badge rounded-pill bg-danger" v-else>
                            <i class="fas fa-times"></i>
                        </span>
                    </td>
                    <td class="text-center">
                        <span class="badge rounded-pill bg-success" v-if="row_data.link_file != null">
                            <i class="fas fa-check"></i>
                        </span>
                        <span class="badge rounded-pill bg-danger" v-else>
                            <i class="fas fa-times"></i>
                        </span>
                    </td>
                    <td class="text-center">
                        <span class="badge rounded-pill bg-success" v-if="row_data.link_video != null">
                            <i class="fas fa-check"></i>
                        </span>
                        <span class="badge rounded-pill bg-danger" v-else>
                            <i class="fas fa-times"></i>
                        </span>
                    </td>

                    <td class="text-center">
                        <span class="badge rounded-pill bg-success" v-if="row_data.is_upload == 'yes'">
                            <i class="fas fa-check"></i>
                        </span>
                        <span class="badge rounded-pill bg-danger" v-else>
                            <i class="fas fa-times"></i>
                        </span>
                    </td>
                    <td class="text-center">
                        <b-button variant="info" size="sm" class="form-control" @click="showModalDetailStages(row_data.mkp_id_agenda)">
                            <i class="fas fa-info"></i>
                            &nbsp;
                            <span><b>Detail</b></span>
                        </b-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <b-modal v-model="modalUploadFile" title="Upload File" title-class="text-black font-18" body-class="p-3" size="md" hide-footer @hidden="closeModalUploadFile">
        <div class="row">
            <div class="col-md-12 text-center">
                List File
            </div>
        </div>
    </b-modal>

    <b-modal v-model="modalFormUpload" title="Upload File" title-class="text-black font-18" body-class="p-3" size="md" hide-footer @hidden="closeModalFormUpload">
        <div class="row">
            <div class="col-md-12">
                <b-form>
                    <b-form-group label="Input File">
                        <input type="file" class="form-control">
                    </b-form-group>
                </b-form>
            </div>
        </div>
    </b-modal>


    <b-modal v-model="modalFormImplementation" title="Form Pelaksanaan" title-class="text-black font-18" body-class="p-3" hide-footer>
        <div class="row">
            <div class="col-md-12">
                <b-form @submit.prevent="storeDateTimeImplementation()">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-group class="mb-3" label="Tanggal Pelaksanaan" label-for="inputDateImplementation">
                                <b-form-input v-model="dateImplementation" id="inputDateImplementation" type="date">
                                </b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group class="mb-3" label="Waktu Pelaksanaan" label-for="inputTimeImplementation">
                                <b-form-input v-model="timeImplementation" id="inputTimeImplementation" type="time">
                                </b-form-input>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-center">
                            <b-button type="submit" variant="success">
                                <i class="fas fa-check"></i> <b>Simpan</b>
                            </b-button>
                        </div>
                    </div>
                </b-form>
            </div>
        </div>
    </b-modal>

    <b-modal v-model="showModal.detailStages" title="Detail Agenda" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer @hidden="closeModalDetailStages">
        <div class="container-fluid" v-if="detailStagesMode == true">
            <div class="row mb-1">
                <div class="col-md-12">
                    <h4><b>{{ dataStage.title_agenda }}</b></h4>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-6">
                    <h6><b>Tipe Tahapan :</b> {{ (dataStage.type_stages != null) ? dataStage.type_stages : '-' }}</h6>
                    <h6><b>Pelaksanaan:</b> {{ (dataStage.date_agenda != null) ? dataStage.date_agenda : '-' }}</h6>
                    <h6>
                        <b>Waktu:</b>
                        {{ dataStage.duration_start }} - {{ dataStage.duration_end }} WIB
                        ({{ (dataStage.duration_agenda != null) ? dataStage.duration_agenda : '0' }} Jam)
                    </h6>
                   

                </div>

                <div class="col-6 text-end align-middle">
                    <b-button v-if="user_role != 7 && user_role != 8" variant="danger" size="sm" id="btnDeleteData" @click="deleteStages()">
                        <i class="fas fa-trash"></i>
                        &nbsp;
                        <span><b>Hapus data</b></span>
                    </b-button>
                    &nbsp;
                    <b-button v-if="user_role != 7 && user_role != 8" variant="warning" size="sm" id="btnEditData" @click="showEditStages()">
                        <i class="fas fa-edit"></i>
                        &nbsp;
                        <span><b>Edit data</b></span>
                    </b-button>
                </div>
                <!-- <table class="table table-striped ">
                        <thead>
                            <tr class="text-center">
                            <th scope="col">Instruktur</th>
                            <th scope="col">Kelompok Instruktur</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td class="text-center"><div v-for="(item, index) in dataStage.instruktur_data" :key="index"> -->
                                                        <!-- Pastikan item memiliki data_instruktur sebelum mencoba mengaksesnya -->
                                                        <!-- <p v-if="item.data_instruktur">{{ item.data_instruktur.nip_name }}</p>
                                                    </div></td>
                            <td class="text-center"><div v-for="(item, index) in dataStage.instruktur_data" :key="index"> -->
                                                        <!-- Pastikan item memiliki data_instruktur sebelum mencoba mengaksesnya -->
                                                        <!-- <p v-if="item.data_instruktur">{{ item.titleKelompokAdd }}</p>
                                                    </div></td>
                            </tr>
                        </tbody>
                    </table> -->

                    <div v-if="dataStage.instruktur_data && dataStage.instruktur_data.length > 0">
                        <table class="table table-striped">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col">Instruktur</th>
                                    <th scope="col">Kelompok Instruktur</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in dataStage.instruktur_data" :key="index">
                                    <!-- Pastikan item memiliki data_instruktur dan titleKelompokAdd -->
                                    <td class="text-center">
                                        <p v-if="item.data_instruktur">{{ item.data_instruktur.nip_name }}</p>
                                    </td>
                                    <td class="text-center">
                                        <p v-if="item.titleKelompokAdd">{{ item.titleKelompokAdd }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- Tampilkan pesan jika tidak ada data -->
                    <p v-else class="text-center">
                        Tidak ada data instruktur dan kelompok sebelumnya
                    </p>

                <div class="col-12">
                    <hr class="mt-2 mb-2" />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <b>Detail Agenda</b>
                </div>
                <div class="col-12">
                    {{ dataStage.detail_agenda }}
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-center">
                    <a :href="dataStage.link_agenda" class="btn btn-primary" target="_blank">
                        <i class="fa fa-video"></i>
                        &nbsp;
                        <b>Link Zoom</b>
                    </a>
                    &nbsp;
                    <a :href="dataStage.link_file" class="btn btn-warning" target="_blank">
                        <i class="fa fa-file"></i>
                        &nbsp;
                        <b>Link File</b>
                    </a>
                    &nbsp;
                    <a v-if="dataStage.link_video != ''" :href="dataStage.link_video" class="btn btn-success" target="_blank">
                        <i class="fa fa-file-alt"></i>
                        &nbsp;
                        <b>Link Materi</b>
                    </a>
                    &nbsp;

                    <div class="col-md-12 text-center">
                <!-- Button untuk Membuka File PDF di Tab Baru -->
                <button
                    v-if="dataStage.upFilePdf"
                    @click="openFile(dataStage.upFilePdf)"
                    class="btn btn-primary mt-3"
                >
                    Buka PDF
                </button>
                &nbsp;
                <!-- Button untuk Membuka File PPT di Tab Baru -->
                <button
                    v-if="dataStage.upFilePpt"
                    @click="openFile(dataStage.upFilePpt)"
                    class="btn btn-success mt-3"
                >
                    Buka PPT
                </button>
                <p v-else>Tidak ada file PPT yang diunggah.</p>
            </div>    
            </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <b>Upload Tugas :</b> ({{ (dataStage.is_upload != null) ? dataStage.is_upload : '-' }})
                    <br>
                    <b>Diadakan Online meeting :</b> ({{ (dataStage.is_online_meet != null) ? dataStage.is_online_meet : '-' }})
                </div>
            </div>
        </div>
        <div class="container-fluid" v-else>
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Pilih Tahapan" label-for="selectStages">
                        <select class="form-select mb-3" id="selectStages" v-model="dataStage.type_stages" @change.prevent="selectStages()">
                            <option value="">-- Pilih Tahapan --</option>
                            <option v-for="(row, index) in listOptSelectStage" :value="row.value" :key="index">{{ row.value }}</option>
                        </select>
                    </b-form-group>

                    <b-form @submit.prevent="storeEditDataStages">
                        <template v-if="dataStage.type_stages == ''">
                            <div class="row">
                                <div class="col-md-12">
                                    <h5 class="text-center">-- Pilih Tahapan Terlebih Dahulu --</h5>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="container-fluid" style="background: #e9ebf7; border-radius: 10px; padding: 10px 8px;">
                                <div class="row">
                                    <div class="col-md-12">
                                        <b-form-group class="mb-3" label="Judul Materi" label-for="titleMateri">
                                            <b-form-input id="titleMateri" placeholder="Masukkan Judul Materi..." type="text" v-model="dataStage.title_agenda">
                                            </b-form-input>
                                        </b-form-group>

                                        <b-form-group class="mb-3" label="Tanggal Pelaksanaan" label-for="dateAgenda">
                                            <b-form-input id="dateAgenda" v-model="dataStage.date_agenda" type="date">
                                            </b-form-input>
                                        </b-form-group>

                                        <b-form-group class="mb-3" label="Jam Pembelajaran" label-for="durationAgenda">
                                            <b-form-input id="durationAgenda" v-model="dataStage.duration_agenda" placeholder="Masukkan Durasi Agenda..." type="number">
                                            </b-form-input>
                                        </b-form-group>

                                        <div class="row">
                                            <div class="col-6">
                                                <b-form-group class="mb-3" label="Jam Dimulai" label-for="durationStart">
                                                    <b-form-input id="durationStart" v-model="dataStage.duration_start" type="time">
                                                    </b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-6">
                                                <b-form-group class="mb-3" label="Jam Selesai" label-for="durationEnd">
                                                    <b-form-input id="durationEnd" v-model="dataStage.duration_end" type="time">
                                                    </b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <b-form-group class="mb-3" label="Kelompok" label-for="selectGroup">
                                            <select class="form-select mb-3" id="selectGroup" v-model="dataStage.group">
                                                <option value="">-- Pilih Kelompok --</option>
                                                <option value="1">I</option>
                                                <option value="2">II</option>
                                                <option value="3">III</option>
                                                <option value="4">IV</option>
                                                <option value="5">Kelompok Gabungan</option>
                                                
                                            </select>
                                        </b-form-group>

                                        <b-form-group class="mb-3" label="Keterangan" label-for="detailAgenda">
                                            <textarea class="form-control" id="detailAgenda" v-model="dataStage.detail_agenda" placeholder="Keterangan Agenda . . ." cols="30" rows="7" style="resize:none;"></textarea>
                                        </b-form-group>

                                        <b-form-group class="mb-3" label="Instruktur" label-for="kelompokInstrukturAdd">
                                            <small>Nama Instruktur dan kelompok sebelumnya:
                                                <div v-if="dataStage.instruktur_data && dataStage.instruktur_data.length > 0">
                                                    <div
                                                        v-for="(item, index) in dataStage.instruktur_data"
                                                        :key="index"
                                                        class="instruktur-item"
                                                    >
                                                        <!-- Pastikan item memiliki data_instruktur dan titleKelompokAdd -->
                                                        <p v-if="item.data_instruktur && item.titleKelompokAdd">
                                                            ({{ item.data_instruktur.nip_name }} - {{ item.titleKelompokAdd }})
                                                        </p>
                                                    </div>
                                                </div>
                                                <p v-else>
                                                    Tidak ada data instruktur dan kelompok sebelumnya
                                                </p>
                                                </small>


                                            <div class="row">
                                                <div class="col-12">
                                                <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
                                                    <thead class="bg-dark text-center text-white">
                                                    <tr>
                                                        <th style="width: 50px">No</th>
                                                        <th style="width: auto">Instruktur</th>
                                                        <th style="width: 35%">Kelompok</th>
                                                        <th style="width: 50px" class="text-center">
                                                        <b-button
                                                            type="button"
                                                            class="btn btn-success btn-sm"
                                                            @click="addRowPeserta()"
                                                        >
                                                            <i class="fa fa-plus"></i>
                                                        </b-button>
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(row_data, key_data) in instruktur_data" :key="key_data">
                                                        <td class="text-center">{{ key_data + 1 }}.</td>
                                                        <td>
                                                        <v-select
                                                            label="nip_name"
                                                            v-model="row_data.data_instruktur"
                                                            :options="peserta_ref"
                                                            @search="onSearchInstruktur"
                                                            placeholder="Cari dan Pilih Instruktur..."
                                                        ></v-select>
                                                        </td>
                                                        <td>
                                                        <b-form-input
                                                        name="kelompok_instruktur"
                                                            placeholder="Masukkan Kelompok..."
                                                            v-model="row_data.titleKelompokAdd"
                                                        ></b-form-input>

                                                        </td>
                                                        <td class="text-center">
                                                        <button
                                                            type="button"
                                                            class="btn btn-danger btn-sm"
                                                            @click="deleteRow(key_data, row_data)"
                                                        >
                                                            <i class="fa fa-minus"></i>
                                                        </button>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                                </div>
                                            </div>
                                        </b-form-group>                          


                                        <b-form-group class="mb-3" label="Link Zoom" label-for="linkAgenda">
                                            <b-form-input id="linkAgenda" v-model="dataStage.link_agenda" placeholder="http://. . . . ." type="url">
                                            </b-form-input>
                                        </b-form-group>

                                        <b-form-group class="mb-3" label="Link File Materi" label-for="linkFile">
                                            <b-form-input id="linkFile" v-model="dataStage.link_file" placeholder="http://. . . . ." type="url">
                                            </b-form-input>
                                        </b-form-group>

                                        <b-form-group class="mb-3" label="Video Materi" label-for="linkVideo">
                                            <b-form-input id="linkVideo" v-model="dataStage.link_video" placeholder="http://. . . . ." type="url">
                                            </b-form-input>
                                        </b-form-group>


                                <div class="col-12">
                                <div class="mb-3">
                                <label for="formPpt" class="form-label">Pilih File PPT</label>

                                <!-- Menampilkan nama file PPT sebelumnya jika ada -->
                                <div v-if="dataStage.upFilePpt" class="mb-2">
                                <small>File Sebelumnya: 
                                    <a :href="dataStage.upFilePpt" target="_blank">{{ getFileName(dataStage.upFilePpt) }}</a>
                                </small>
                                </div>

                                <!-- Input untuk upload file baru -->
                                <input
                                class="form-control"
                                name="uploadFilePpt"
                                type="file"
                                id="formPpt"
                                v-on:change="uploadFilePptt($event)"
                                />
                                <div class="respond-input-file float-left" id="uploadLoadingPpt"></div>
                                <small class="float-right" style="color: red">
                                *) Max File 2 MB & File Wajib PPT
                                </small>
                            </div>
                            </div>

                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="formPdf" class="form-label">Pilih File PDF</label>
                                    <!-- Menampilkan nama file PPT sebelumnya jika ada -->
                                <div v-if="dataStage.upFilePdf" class="mb-2">
                                <small>File Sebelumnya: 
                                    <a :href="dataStage.upFilePdf" target="_blank">{{ getFileName(dataStage.upFilePdf) }}</a>
                                </small>
                                </div>
                                    
                                    <input
                                    class="form-control"
                                    name="uploadFilePdf"
                                    type="file"
                                    id="formPdf"
                                    v-on:change="uploadFilePpdf($event)"
                                    />
                                    <div class="respond-input-file float-left" id="uploadLoadingPdf"></div>
                                    <small class="float-right" style="color: red">
                                    *) Max File 2 MB & File Wajib PDF
                                    </small>
                                </div>
                                </div>

                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <b-form-group label="Apakah upload tugas ?">
                                            <div>
                                                <b-form-radio class="d-inline-block" v-model="dataStage.is_upload" name="questionUpload" value="yes">
                                                    Yes
                                                </b-form-radio>
                                                &nbsp;
                                                <b-form-radio class="d-inline-block" v-model="dataStage.is_upload" name="questionUpload" value="no">
                                                    No
                                                </b-form-radio>
                                            </div>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-6">
                                        <b-form-group label="Apakah ada online meeting ?">
                                            <div>
                                                <b-form-radio class="d-inline-block" v-model="dataStage.is_online_meet" name="questionOnlineMeet" value="yes">
                                                    Yes
                                                </b-form-radio>
                                                &nbsp;
                                                <b-form-radio class="d-inline-block" v-model="dataStage.is_online_meet" name="questionOnlineMeet" value="no">
                                                    No
                                                </b-form-radio>
                                            </div>
                                        </b-form-group>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <hr style="background:grey; height: 2px; border-radius: 25%;">
                                    </div>
                                    <div class="col-md-12 text-end">
                                        <b-button role="button" variant="danger" @click="closeEditStages()">
                                            <i class="fas fa-arrow-left"></i> <b>Kembali</b>
                                        </b-button>
                                        &nbsp;
                                        <b-button type="sumbit" variant="success">
                                            <i class="fas fa-check"></i> <b>Simpan</b>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </b-form>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<style scoped>
.instruktur-item p {
  margin: 2px 0; /* Atur jarak vertikal antar elemen */
  line-height: 1.2; /* Sesuaikan tinggi baris agar lebih rapat */
}
</style>
